var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueApexCharts',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"role":"img","aria-label":"Répartition par famille de produit","height":this.height || 'auto',"width":this.width || '100%'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }